import 'twin.macro';

import { Icon, Stack, Text } from '@cheqroom/ui';
import { ReactNode } from 'react';

import { Location } from '../../../../../../@types/python.d';
import { getIcon } from './utils';

/**
 * Creates tooltip content showing the full location path with icons
 */
export const createLocationPathTooltip = (locations: Location[] | undefined): ReactNode => {
	if (!locations || locations.length === 0) {
		return undefined;
	}

	return (
		<Stack vertical>
			{locations.map((loc) => {
				const LocIcon = getIcon(loc.icon, true);
				return (
					<Stack key={loc._id} spacing="extraTight" align="center">
						{LocIcon && <Icon color="white" source={LocIcon} size="small" />}
						<Text tw="text-white" size="small">
							{loc.name}
						</Text>
					</Stack>
				);
			})}
		</Stack>
	);
};
